import React from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'

export const RefreshButton = ({ updateHandler }) => {

  return (
    <OverlayTrigger
      placement='bottom'
      overlay={
        <Tooltip>
         <strong>Actualizar</strong>
        </Tooltip>
      }
    >
      <Button variant="primary" onClick={updateHandler} >
        <i className=" fa fa-refresh"></i>
      </Button>
    </OverlayTrigger>
  )
}
